var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-down"}},[(!_vm.isOnline)?_c('div',{staticClass:"network-status-bar"},[_c('i',{staticClass:"el-icon-warning"}),_c('span',[_vm._v("网络连接已断开，请检查您的网络设置")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }